import { TRANSLATIONS } from './translations';

/** One headed block of a legal document. */
export interface ILegalSection {
  headingKey: string;
  bodyKeys: string[];
}

export interface ILegalDocument {
  titleKey: string;
  /** Shown under the title, before the first heading. */
  introKey?: string;
  /** ISO date, rendered through LEGAL_UPDATED_AT. Bump it on every real change. */
  updatedAt: string;
  sections: ILegalSection[];
}

/**
 * The legal pages, as data.
 *
 * Structured like this -- headings and paragraphs as translation keys rather
 * than one giant blob of markdown -- for the same reason INFO_PAGES is:
 * these texts have to exist in all three languages, and a document that is
 * one key per language drifts between them the first time a paragraph is
 * amended in Spanish only.
 *
 * Only the landing's own privacy policy exists today. It deliberately covers
 * NOTHING but the waiting list, because that is all this site does: no
 * accounts, no bookings, no payments. The platform's full policy is a
 * separate, much longer document (drafted in the API repo under
 * docs/legal/) that belongs here as a second entry the day the platform
 * actually opens -- not before, since a policy describing bookings and
 * operator documents would be describing things that happen to nobody.
 */
export const LEGAL_DOCUMENTS: Record<string, ILegalDocument> = {
  privacidad: {
    titleKey: TRANSLATIONS.PRIVACY_LANDING_TITLE,
    introKey: TRANSLATIONS.PRIVACY_LANDING_SCOPE,
    updatedAt: '2026-09-24',
    sections: [
      {
        headingKey: TRANSLATIONS.PRIVACY_LANDING_CONTROLLER_HEADING,
        // The identity paragraph is rendered by the page itself, not from
        // here: it is the one block that depends on whether LEGAL_ENTITY has
        // been filled in yet.
        bodyKeys: [TRANSLATIONS.PRIVACY_LANDING_CONTROLLER_CONTACT],
      },
      {
        headingKey: TRANSLATIONS.PRIVACY_LANDING_DATA_HEADING,
        bodyKeys: [TRANSLATIONS.PRIVACY_LANDING_DATA_BODY_1, TRANSLATIONS.PRIVACY_LANDING_DATA_BODY_2],
      },
      {
        headingKey: TRANSLATIONS.PRIVACY_LANDING_PURPOSE_HEADING,
        bodyKeys: [TRANSLATIONS.PRIVACY_LANDING_PURPOSE_BODY_1, TRANSLATIONS.PRIVACY_LANDING_PURPOSE_BODY_2],
      },
      {
        headingKey: TRANSLATIONS.PRIVACY_LANDING_BASIS_HEADING,
        bodyKeys: [TRANSLATIONS.PRIVACY_LANDING_BASIS_BODY],
      },
      {
        headingKey: TRANSLATIONS.PRIVACY_LANDING_SHARING_HEADING,
        bodyKeys: [TRANSLATIONS.PRIVACY_LANDING_SHARING_BODY_1, TRANSLATIONS.PRIVACY_LANDING_SHARING_BODY_2],
      },
      {
        headingKey: TRANSLATIONS.PRIVACY_LANDING_RETENTION_HEADING,
        bodyKeys: [TRANSLATIONS.PRIVACY_LANDING_RETENTION_BODY],
      },
      {
        headingKey: TRANSLATIONS.PRIVACY_LANDING_RIGHTS_HEADING,
        bodyKeys: [TRANSLATIONS.PRIVACY_LANDING_RIGHTS_BODY_1, TRANSLATIONS.PRIVACY_LANDING_RIGHTS_BODY_2],
      },
      {
        headingKey: TRANSLATIONS.PRIVACY_LANDING_NO_EMAIL_HEADING,
        bodyKeys: [TRANSLATIONS.PRIVACY_LANDING_NO_EMAIL_BODY],
      },
    ],
  },
};
